<template>
  <section>
    <p class="text-sm font-normal text-fg-muted">Network</p>
    <div class="flex items-center gap-x-2 mt-4">
      <div
        v-for="(item, index) in selectedWalletAddresses"
        :key="index"
        class="flex items-center"
      >
        <div
          class="flex items-center border rounded-full px-4 py-2 gap-x-2"
          :class="
            selectedAssetAccountDetails.id === item.id
              ? 'border-primary bg-secondary-2'
              : ''
          "
          @click="selectNetwork(item)"
        >
          <div class="flex items-center">
            <network-icon
              :currency="getNetworkFullName(item.network)"
              size="h-4 w-4"
            />
          </div>
          <div class="text-muted-fg font-normal text-xs">
            {{ item.network }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedAssetAccountDetails" class="mt-3">
      <div
        class="mt-4 px-8 rounded-lg flex flex-col items-center justify-center"
      >
        <p class="text-gray-muted font-medium mb-10">
          Scan address to make deposit
        </p>

        <qrcode-vue
          :value="selectedAssetAccountDetails.walletAddress"
          :size="200"
          level="H"
          class="mb-5"
        />
      </div>
      <div
        class="flex justify-between items-center px-5 border rounded-md py-3 mb-2"
      >
        <p class="text-xs font-normal text-fg-muted">Asset</p>
        <div class="flex items-center gap-x-2">
          <currency-icons
            :currency="getCurrencyCountry(selectedAssetAccountDetails.asset)"
          />
          <p class="text-black font-medium text-sm">
            {{ selectedAssetAccountDetails.asset }}
          </p>
        </div>
      </div>
      <div
        class="flex justify-between items-center px-5 border rounded-md py-3 mb-2"
      >
        <p class="text-xs font-normal text-fg-muted">Network</p>
        <div class="flex items-center gap-x-2">
          <network-icon
            :currency="getNetworkFullName(selectedAssetAccountDetails.network)"
          />
          <p class="text-black font-medium text-sm">
            {{ selectedAssetAccountDetails.network }}
          </p>
        </div>
      </div>
      <div
        class="flex justify-between items-center px-5 border rounded-md py-3 mb-2"
      >
        <p class="text-xs font-normal text-fg-muted">Wallet Address</p>
        <div class="flex items-center mt-3">
          <p class="text-xs text-black font-medium mr-0.5">
            {{ maskID(selectedAssetAccountDetails.walletAddress) }}
          </p>
          <div
            class="cursor-pointer"
            v-clipboard:copy="selectedAssetAccountDetails.walletAddress"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center mt-5">
        <div
          class="flex items-center justify-center gap-x-4 px-3 py-2 rounded-md shadow-sm border border-red-2 bg-pink-1"
        >
          <warning-icon-red size="h-6 w-6" color="#FF0000" />
          <p class="text-red-1 text-sm font-normal">
            Only send {{ selectedAssetAccountDetails.asset }} ({{
              selectedAssetAccountDetails.network
            }}) to this address
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  GetNetworkFullName,
  GetCurrencyCountry,
  MaskID
} from '@/utils/helpers.js'
import QrcodeVue from 'qrcode.vue'
export default {
  props: {
    selectedAsset: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedAssetAccountDetails: {}
    }
  },
  components: {
    NetworkIcon: () => import('@/assets/v2/icons/NetworkIcons.vue'),
    WarningIconRed: () => import('@/assets/v2/icons/WarningIconRed.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    QrcodeVue
  },
  methods: {
    maskID (val) {
      return MaskID(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    getNetworkFullName (val) {
      return GetNetworkFullName(val)
    },
    selectNetwork (item) {
      this.selectedAssetAccountDetails = this.selectedWalletAddresses.find(
        (data) => data.id === item.id
      )
    }
  },
  beforeMount () {
    this.selectedAssetAccountDetails = this.selectedWalletAddresses[0]
  },
  computed: {
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items
    },
    selectedWalletAddresses () {
      return this.walletAddresses.filter(
        (item) =>
          item.asset === this.selectedAsset &&
          item.reason === this.$transactionType.DEPOSIT
      )
    }
  }
}
</script>
